import { Link } from '@tanstack/react-router'
import { useState } from 'react'
import {
	APP_LANGUAGES,
	type AppLanguageCode,
	changeAppLanguage,
	resolveAppLanguageCode
} from '@/lib/i18n'
import { createSiteTranslate } from '../-lib/site-i18n'
import { SiteLogo } from './site-logo'

export function SiteHeader(props: { appLanguage: AppLanguageCode }) {
	const t = createSiteTranslate(props.appLanguage)
	const [open, setOpen] = useState(false)
	const close = () => setOpen(false)

	return (
		<header className='nav'>
			<div className='wrap nav-in'>
				<SiteLogo />
				<nav className={open ? 'nav-links open' : 'nav-links'}>
					<Link hash='come-funziona' onClick={close} to='/'>
						{t('site:nav.how')}
					</Link>
					<Link hash='funzionalita' onClick={close} to='/'>
						{t('site:nav.features')}
					</Link>
					<Link onClick={close} to='/changelog'>
						{t('site:nav.news')}
					</Link>
					<Link onClick={close} to='/support'>
						{t('site:nav.support')}
					</Link>
				</nav>
				<div className='nav-cta'>
					<select
						aria-label={t('site:nav.language')}
						className='lang-select'
						// SSR renders site copy from the cookie-derived language, so
						// persist the choice then reload to re-render in it.
						onChange={(event) => {
							changeAppLanguage(
								resolveAppLanguageCode(event.target.value)
							)
							window.location.reload()
						}}
						value={props.appLanguage}
					>
						{APP_LANGUAGES.map((language) => (
							<option key={language.code} value={language.code}>
								{language.label}
							</option>
						))}
					</select>
					<Link className='btn btn-pri btn-sm' hash='scarica' to='/'>
						{t('site:nav.download')}
					</Link>
					<button
						aria-label={t('site:nav.menu')}
						className='nav-burger'
						onClick={() => setOpen((value) => !value)}
						type='button'
					>
						<svg
							aria-hidden='true'
							fill='none'
							height='20'
							viewBox='0 0 24 24'
							width='20'
						>
							<path
								d='M4 7h16M4 12h16M4 17h16'
								stroke='white'
								strokeLinecap='round'
								strokeWidth='1.8'
							/>
						</svg>
					</button>
				</div>
			</div>
		</header>
	)
}
